module.exports = __webpack_public_path__ + "catalog/items/firesafety/Fire-Hose/Fire-Hose.svg";